import { StorePagination } from "../../../../DashboardPagination"
import { productActions } from "../../../../../store/products-slice"

const Pagination = ({ index }) => {
    return <StorePagination index={index} sliceName="product" actions={productActions} label="Produkte Seitennavigation" />
}

export default Pagination;
